import React from 'react'
import classNames from 'classnames'

import { IconStarFull as IconStar } from 'components/UI/Icons'
import Typography from 'components/UI/Typography/Typography'

import styles from './Rating.module.css'

export const Rating: React.FC<{ value: number }> = ({ value }) => {
  return (
    <div className={styles.rating}>
      {Array(5)
        .fill(0)
        .map((_, i) => {
          return (
            <IconStar
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              className={classNames(styles.starIcon, {
                [styles.starIconFilled]: i < value,
              })}
              height={14}
            />
          )
        })}

      <Typography.BodySmall>{value}/5</Typography.BodySmall>
    </div>
  )
}

export default Rating
